import ComponentHelper from '../../supers/ComponentHelper';
import React from 'react';
import Toggle from 'react-toggle';
import './toggle-row.css';

class ToggleRow extends ComponentHelper {
	render() {
		let { className, name, details, content, onToggle, toggleOn, icon, offContent, keyName, disabled, required } = this.props;
		let contentElement = null;

		if (content) {
			contentElement = <div className="toggleable-content animated fadeIn">{content}</div>;
		}

		return (
			<div className={`toggle-row ${className ? className : ''}`}>
				<div className="row-content hbox vcenter">
					<div className="vbox vcenter grow-1">
						<div className="name">
							{name}
							{required ? <span>*</span> : ''}
						</div>
						<div className="details hbox vcenter">
							{icon} {details}
						</div>
					</div>
					<Toggle onChange={onToggle} checked={toggleOn} data-name={keyName} disabled={disabled} />
				</div>
				{toggleOn && contentElement}
				{!toggleOn && offContent}
			</div>
		);
	}
}

export default ToggleRow;



// WEBPACK FOOTER //
// ./src/components/toggle-row/ToggleRow.js